export const HEADER_LOGIN_REQUEST_EVENT = "raffle:request-header-login";

export function requestHeaderLogin() {
  window.dispatchEvent(new Event(HEADER_LOGIN_REQUEST_EVENT));
}
